import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../core/auth/auth.service';
import { AuthProvider } from '../../core/auth/auth.config';

@Component({
  selector: 'app-auth-callback',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="govuk-width-container">
      <main class="govuk-main-wrapper" id="main-content" role="main">
        <div class="govuk-grid-row">
          <div class="govuk-grid-column-two-thirds">
            
            <div class="callback-status">
              <div class="spinner-container">
                <div class="govuk-loader"></div>
              </div>
              
              <h1 class="govuk-heading-l">
                Overovanie prihlásenia...
              </h1>
              
              <p class="govuk-body">
                Prosím čakajte, spracovávame vaše prihlásenie.
              </p>
              
              <div class="govuk-warning-text govuk-!-margin-top-6">
                <span class="govuk-warning-text__icon" aria-hidden="true">!</span>
                <strong class="govuk-warning-text__text">
                  <span class="govuk-warning-text__assistive">Upozornenie</span>
                  Ak táto stránka nezmiznе do 5 sekúnd, skontrolujte konzolu prehliadača (F12).
                </strong>
              </div>
            </div>

          </div>
        </div>
      </main>
    </div>
  `,
  styles: [`
    .callback-status {
      text-align: center;
      padding: 2rem 0;
    }

    .spinner-container {
      margin-bottom: 2rem;
    }

    .govuk-loader {
      width: 60px;
      height: 60px;
      border: 4px solid #b1b4b6;
      border-top-color: #1d70b8;
      border-radius: 50%;
      animation: spin 1s linear infinite;
      margin: 0 auto;
    }

    @keyframes spin {
      to { transform: rotate(360deg); }
    }

    .govuk-main-wrapper {
      padding-top: 40px;
    }
  `]
})
export class AuthCallbackComponent implements OnInit {
  private authService = inject(AuthService);
  private router = inject(Router);

  /** Navigate to /login, preserving the provider stored in sessionStorage. */
  private goToLogin() {
    const provider = sessionStorage.getItem('auth_provider') as AuthProvider | null;
    if (provider && provider !== 'default') {
      this.router.navigate(['/login', provider]);
    } else {
      this.router.navigate(['/login']);
    }
  }

  ngOnInit() {
    console.log('🔄 AuthCallback: Spracovavam OAuth callback...');
    console.log('Current URL:', window.location.href);
    console.log('Query params:', window.location.search);

    // When authentication completes successfully, navigate to the main page.
    this.authService.isAuthenticated$.subscribe(isAuth => {
      console.log('AuthCallback: Auth status:', isAuth);
      if (isAuth) {
        console.log('✅ AuthCallback: Prihlasenie uspesne, presmerovavam na hlavnu stranku');
        this.router.navigateByUrl('');
      }
    });

    // Fallback: if not logged in after 10 s, go to the login page.
    // Preserves the provider (e.g. /login/ardaco) so the user lands on the
    // correct login form after a failed silent-login attempt.
    setTimeout(() => {
      if (!this.authService.isLoggedIn()) {
        console.log('AuthCallback: Timeout - prihlasenie zlyhalo, presmerovavam na login');
        this.goToLogin();
      }
    }, 10000);
  }
}
